// import { useState, useEffect, useRef } from "react";
// import "../Styles/Testimonials.css";

// const Testimonial = () => {
//   // Sample testimonial data - you can replace with your actual data
//   const testimonials = [
//     {
//       id: 1,
//       name: "John Doe",
//       role: "Farmer, Green Acres",
//       content:
//         "The agricultural solutions provided have transformed my farming practices. Crop yields have increased by 30% and the quality has never been better. I'm grateful for the support and guidance throughout the process.",
//     },
//     {
//       id: 2,
//       name: "Sarah Johnson",
//       role: "Organic Farmer, Sunrise Farms",
//       content:
//         "As an organic farmer, I was looking for sustainable solutions. The team understood my needs perfectly and provided eco-friendly options that aligned with my values while improving productivity.",
//     },
//     {
//       id: 3,
//       name: "Michael Chen",
//       role: "Agricultural Consultant",
//       content:
//         "I've recommended these services to numerous clients, and the feedback has been consistently positive. The innovative approaches to modern farming challenges are truly impressive.",
//     },
//     {
//       id: 4,
//       name: "Emily Rodriguez",
//       role: "Small-scale Farmer",
//       content:
//         "Being a small-scale farmer comes with unique challenges. The personalized attention and tailored solutions have made a significant difference in my operations and profitability.",
//     },
//     {
//       id: 5,
//       name: "David Wilson",
//       role: "Ranch Owner, Wilson Estates",
//       content:
//         "The comprehensive approach to land management has revitalized our ranch. From soil health to water conservation, every aspect has been addressed with expertise and care.",
//     },
//     // Add 15 more testimonials to reach the total of 20
//     {
//       id: 6,
//       name: "Lisa Thompson",
//       role: "Vineyard Manager",
//       content:
//         "Our vineyard has flourished since implementing the recommended practices. The attention to detail and understanding of our specific needs has been exceptional.",
//     },
//     {
//       id: 7,
//       name: "Robert Garcia",
//       role: "Dairy Farmer",
//       content:
//         "The solutions for our dairy farm have improved both animal welfare and production efficiency. I appreciate the holistic approach that considers all aspects of our operation.",
//     },
//     {
//       id: 8,
//       name: "Jennifer Lee",
//       role: "Greenhouse Operator",
//       content:
//         "The specialized knowledge for greenhouse cultivation has helped us optimize our growing conditions and extend our growing season significantly.",
//     },
//     {
//       id: 9,
//       name: "Thomas Brown",
//       role: "Fruit Grower",
//       content:
//         "The pest management strategies have saved our orchards from devastating losses. The sustainable approaches align perfectly with our commitment to quality produce.",
//     },
//     {
//       id: 10,
//       name: "Patricia Martinez",
//       role: "Community Garden Coordinator",
//       content:
//         "Our community garden has become a model for urban agriculture thanks to the innovative solutions and ongoing support we've received.",
//     },
//     {
//       id: 11,
//       name: "Kevin Taylor",
//       role: "Grain Farmer",
//       content:
//         "The soil analysis and custom fertilization plan increased our grain yield beyond expectations. The return on investment has been remarkable.",
//     },
//     {
//       id: 12,
//       name: "Amanda White",
//       role: "Organic Certification Specialist",
//       content:
//         "The transition to organic farming was made seamless with the comprehensive guidance provided. Our clients have successfully achieved certification with minimal challenges.",
//     },
//     {
//       id: 13,
//       name: "James Robinson",
//       role: "Livestock Farmer",
//       content:
//         "The integrated approach to livestock management and pasture rotation has improved animal health and reduced our environmental footprint.",
//     },
//     {
//       id: 14,
//       name: "Sophia Kim",
//       role: "Hydroponic Farmer",
//       content:
//         "The specialized knowledge in hydroponic systems has helped us optimize our water and nutrient usage, resulting in consistent, high-quality produce year-round.",
//     },
//     {
//       id: 15,
//       name: "Daniel Clark",
//       role: "Agricultural Educator",
//       content:
//         "I've incorporated many of these practices into my teaching curriculum. The practical, science-based approaches provide excellent learning opportunities for future farmers.",
//     },
//     {
//       id: 16,
//       name: "Olivia Scott",
//       role: "Sustainable Farming Advocate",
//       content:
//         "The balance between productivity and sustainability demonstrated in these farming practices is exactly what our industry needs to move forward responsibly.",
//     },
//     {
//       id: 17,
//       name: "Nathan Patel",
//       role: "Tech-Forward Farmer",
//       content:
//         "The integration of technology with traditional farming knowledge has created a perfect blend that has modernized our operations while respecting time-tested practices.",
//     },
//     {
//       id: 18,
//       name: "Rachel Green",
//       role: "Flower Farmer",
//       content:
//         "Our flower farm has thrived with the specialized care recommendations. The attention to soil health has resulted in vibrant blooms and extended flowering periods.",
//     },
//     {
//       id: 19,
//       name: "Carlos Mendez",
//       role: "Coffee Grower",
//       content:
//         "The expertise in tropical agriculture has been invaluable for our coffee plantation. The quality improvement has allowed us to access premium markets.",
//     },
//     {
//       id: 20,
//       name: "Grace Williams",
//       role: "Family Farm Owner",
//       content:
//         "As a fifth-generation farmer, I was hesitant to change our methods, but the respectful approach to our traditions while introducing improvements has won me over completely.",
//     },
//   ];

//   const [currentIndex, setCurrentIndex] = useState(0);
//   const timerRef = useRef(null);

//   // Function to go to the next testimonial
//   const nextTestimonial = () => {
//     setCurrentIndex((prevIndex) => (prevIndex + 1) % testimonials.length);
//   };

//   // Function to go to the previous testimonial
//   const prevTestimonial = () => {
//     setCurrentIndex((prevIndex) =>
//       prevIndex === 0 ? testimonials.length - 1 : prevIndex - 1
//     );
//   };

//   // Set up auto-rotation
//   useEffect(() => {
//     // Clear any existing timer
//     if (timerRef.current) {
//       clearInterval(timerRef.current);
//     }

//     // Set up a new timer
//     timerRef.current = setInterval(() => {
//       nextTestimonial();
//     }, 5000); // 5 seconds

//     // Clean up the timer when component unmounts
//     return () => {
//       if (timerRef.current) {
//         clearInterval(timerRef.current);
//       }
//     };
//   }, [currentIndex]); // Reset timer when currentIndex changes

//   // Reset timer when user manually navigates
//   const handleManualNavigation = (callback) => {
//     // Clear existing timer
//     if (timerRef.current) {
//       clearInterval(timerRef.current);
//     }

//     // Execute the navigation callback
//     callback();

//     // Set up a new timer
//     timerRef.current = setInterval(() => {
//       nextTestimonial();
//     }, 5000);
//   };

//   return (
//     <div className="testimonial-section">
//       <h2 className="testimonial-heading">Testimonial</h2>
//       <div className="testimonial-container">
//         <div className="phone-mockup">
//           {/* The background image will be set in CSS */}
//         </div>
//         <div className="testimonial-card">
//           <div className="testimonial-content">
//             <p>"{testimonials[currentIndex].content}"</p>
//             <div className="testimonial-author">
//               <h4>{testimonials[currentIndex].name}</h4>
//               <p>{testimonials[currentIndex].role}</p>
//             </div>
//           </div>
//         </div>
//       </div>
//       <div className="testimonial-navigation">
//         <button
//           className="nav-button prev-button"
//           onClick={() => handleManualNavigation(prevTestimonial)}
//           aria-label="Previous testimonial"
//         >
//           &larr;
//         </button>
//         <div className="testimonial-indicators">
//           {testimonials.map((_, index) => (
//             <span
//               key={index}
//               className={`indicator ${index === currentIndex ? "active" : ""}`}
//               onClick={() => {
//                 handleManualNavigation(() => setCurrentIndex(index));
//               }}
//             />
//           ))}
//         </div>
//         <button
//           className="nav-button next-button"
//           onClick={() => handleManualNavigation(nextTestimonial)}
//           aria-label="Next testimonial"
//         >
//          &rarr;
//         </button>
//       </div>
//     </div>
//   );
// };

// export default Testimonial;

import { useState, useEffect, useRef } from "react";
import "../Styles/Testimonials.css";
import { useTranslation } from "react-i18next";

const Testimonial = () => {
  const { t } = useTranslation();
  const testimonials = t("testimonial.reasons", { returnObjects: true });

  const [currentIndex, setCurrentIndex] = useState(0);
  const timerRef = useRef(null);

  // Function to go to the next testimonial
  const nextTestimonial = () => {
    setCurrentIndex((prevIndex) => (prevIndex + 1) % testimonials.length);
  };

  // Function to go to the previous testimonial
  const prevTestimonial = () => {
    setCurrentIndex((prevIndex) =>
      prevIndex === 0 ? testimonials.length - 1 : prevIndex - 1
    );
  };

  // Set up auto-rotation
  useEffect(() => {
    if (timerRef.current) {
      clearInterval(timerRef.current);
    }
    timerRef.current = setInterval(() => {
      nextTestimonial();
    }, 5000);

    return () => {
      if (timerRef.current) {
        clearInterval(timerRef.current);
      }
    };
  }, [currentIndex, testimonials]);

  // Reset timer when user manually navigates
  const handleManualNavigation = (callback) => {
    if (timerRef.current) {
      clearInterval(timerRef.current);
    }
    callback();
    timerRef.current = setInterval(() => {
      nextTestimonial();
    }, 5000);
  };

  return (
    <div className="testimonial-section">
      <h2 className="testimonial-heading">{t("testimonial.testimonialTitle")}</h2>
      <div className="testimonial-container">
        <div className="phone-mockup" />
        <div className="testimonial-card">
          <div className="testimonial-content">
            <p>"{testimonials[currentIndex]?.content}"</p>
            <div className="testimonial-author">
              <h4>{testimonials[currentIndex]?.name}</h4>
              <p>{testimonials[currentIndex]?.role}</p>
            </div>
          </div>
        </div>
      </div>
      <div className="testimonial-navigation">
        <button
          className="nav-button prev-button"
          onClick={() => handleManualNavigation(prevTestimonial)}
          aria-label="Previous testimonial"
        >
          &larr;
        </button>
        <div className="testimonial-indicators">
          {testimonials.map((_, index) => (
            <span
              key={index}
              className={`indicator ${index === currentIndex ? "active" : ""}`}
              onClick={() => {
                handleManualNavigation(() => setCurrentIndex(index));
              }}
            />
          ))}
        </div>
        <button
          className="nav-button next-button"
          onClick={() => handleManualNavigation(nextTestimonial)}
          aria-label="Next testimonial"
        >
          &rarr;
        </button>
      </div>
    </div>
  );
};

export default Testimonial;
